export const ACCEPTED_IMAGE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/gif",
  "image/webp",
];

export const ACCEPTED_VIDEO_TYPES = [
  "video/mp4",
  "video/mpeg",
  "video/quicktime",
  "video/x-msvideo",
  "video/webm",
];

export const ACCEPTED_MEDIA_TYPES = [
  ...ACCEPTED_IMAGE_TYPES,
  ...ACCEPTED_VIDEO_TYPES,
];

export const FILE_INPUT_ACCEPT = {
  IMAGE: "image/*",
  VIDEO: "video/*",
  MEDIA: "image/*,video/*",
};

export const FILE_TYPE = {
  IMAGE: "image",
  VIDEO: "video",
};

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

